<template>
  <v-container>
    <div class="grey--text mb-5 text-h4">Users</div>

    <v-card outlined>      
      <v-data-table
        :headers="headers"
        :items="users"
        :items-per-page="15"
        class="elevation-1"
      >
        <template v-slot:item.created="{ item }">
          {{ item.data.created.toDate() | date('do MMM yyyy') }}
        </template>
      </v-data-table>
    </v-card>
  </v-container>
</template>

<script>
import firebase from '@/firebase.config'

export default {
  name: "Users",
  data: function () {
    return {
      headers: [
          { text: 'Signup', value: 'created' },
          { text: 'Name', value: 'data.displayName'},
          { text: 'Email', value: 'data.email' },
          { text: 'User type', value: 'data.userType' }
        ],
      users: []
    }
  },
  created() {
    let query = firebase.firestore().collection('users')
    query.onSnapshot(res => {
      const changes = res.docChanges()
      changes.forEach(change => {
        if (change.type === 'added') {
          const user = {
            data: change.doc.data(),
            id: change.doc.id,
          }
          this.users.push(user)
        }
      })
    })
  }
}
</script>

<style scoped>
</style>
